<template>
  <div class="invoice-record">
    <div class="record-card">
      <div class="my-card-title">等待开票</div>
      <div class="table-wrap">
        <div class="flex-grow mgb10">
          <el-button type="warning" size="small" :disabled="multipleSelection.length === 0"
            @click="handleMultiInvoice">批量开票</el-button>
        </div>
        <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column label="编号" align="center" width="60" prop="id">
          </el-table-column>
          <el-table-column label="订单描述" align="center" minWidth="150" prop="body">
          </el-table-column>
          <el-table-column label="支付单号" align="center" width="180" prop="pay_no">
          </el-table-column>
          <el-table-column label="开票金额" align="center" width="100">
            <template slot-scope="{row}">
              <span>{{ formatPrice(row.price) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100" prop="status_name">
          </el-table-column>
          <el-table-column label="创建时间" align="center" width="100" prop="create_time">
          </el-table-column>
          <el-table-column label="操作" align="center" width="100" fixed="right">
            <template slot-scope="{row}">
              <el-link class="colorBlue" @click="handleAddInvoice(row)" :underline="false">开票</el-link>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex-row mgt20">
          <div class="flex-grow-1"></div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新建发票 -->
    <add-invoice :ids="ids" :visible.sync="showAddForm" @getList="getList" />
  </div>
</template>

<script>
import { getApplyList } from "@/api/invoice";
import AddInvoice from './components/addInvoice.vue';
export default {
  name: 'InvoiceList',
  components: {
    AddInvoice
  },
  data() {
    return {
      loading: true,
      emptyText: '暂无数据',
      listQuery: {
        status: '0',
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
      multipleSelection: [],
      showAddForm: false,
      ids: ''
    };
  },
  computed: {

  },
  created() {
    this.formatPrice = this.utils.formatPrice
    this.getList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleMultiInvoice() {
      const ids = [];
      this.multipleSelection.map((item) => {
        ids.push(item.id);
      });
      if (ids.length > 0) {
        this.ids = ids.join(',');
        this.showAddForm = true;
      } else {
        this.$message.error('请选择数据!');
      }
    },
    handleAddInvoice(row) {
      this.ids = row.id
      this.showAddForm = true;
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getApplyList(_listQuery)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDetail(row) {
      this.$router.push({ path: '/invoice/detail', query: { id: row.id } })
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
.invoice-record {
  width: 100%;
  padding: 25px 0 227px 0;

  .record-card {
    background: #FFFFFF;

    .table-wrap {
      padding: 20px 32px;

    }
  }
}
</style>
